import { useMemo, useState } from 'react'
import type { SavedStatusCheck, StatusCheckResponse } from '../types'
import StatusCheckModal from './StatusCheckModal'

function labelForItem(item: SavedStatusCheck): string {
  const iso = item.as_of || item.payload?.now || item.created_at
  const dt = iso ? new Date(iso) : null
  const stamp = dt && !Number.isNaN(dt.getTime()) ? dt.toLocaleString() : 'Unknown time'
  return `News summary • ${stamp}`
}

export default function SavedNewsSummaries({ items }: { items: SavedStatusCheck[] }) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<StatusCheckResponse | null>(null)

  const newsItems = useMemo(() => items.filter((i) => (i.mode || '').toLowerCase() === 'news'), [items])
  if (!newsItems.length) return null

  return (
    <>
      <div className="mt-3 border-t border-rule pt-3">
        <div className="text-xs text-muted tracking-wider font-semibold">SAVED NEWS SUMMARIES</div>
        <div className="mt-2 flex flex-wrap gap-2">
          {newsItems.slice(0, 6).map((item) => (
            <button
              key={item.status_check_id}
              type="button"
              className="rounded-full border border-rule bg-paper px-3 py-1.5 text-xs text-ink/90 hover:bg-white/40 transition max-w-full"
              title={item.headline_summary || ''}
              onClick={(e) => {
                e.stopPropagation()
                // We filter by mode === 'news', but TS can't narrow the union here.
                setData(item.payload as StatusCheckResponse)
                setOpen(true)
              }}
            >
              <span className="truncate block max-w-[420px]">{labelForItem(item)}</span>
            </button>
          ))}
        </div>
      </div>

      <StatusCheckModal open={open} onClose={() => setOpen(false)} data={data} showSaveButton={false} />
    </>
  )
}


